var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import { openQuickbetModal as openQuickbetModalAction, closeQuickbetModal as closeQuickbetModalAction } from '../../actions/coupon/creators/quickbet';
import { openAuthModal as openAuthModalAction, } from '../../actions/auth/creators/Login';
import { fetchClientInfo as fetchClientInfoAction } from '../../actions/creators/client';
import { getGambler as getGamblerAction } from '../../actions/profile/creators/profile';
import { openBetSlipModal as openBetSlipModalAction, closeBetSlipModal as closeBetSlipModalAction } from '../../actions/coupon/creators/coupon';
import { appendPromoVisit as appendPromoVisitAction } from '../../actions/creators/promo';
import { toggleSidebar as toggleSidebarAction, toggleUserMenu as toggleUserMenuAction } from '../../actions/creators/sidebar';
import { loadRestore as loadRestoreAction } from '../../actions/auth/creators/restore';
import { signIn as signInAction, getFreebet as getFreebetAction } from '../../actions/auth/creators/SignIn';
import routes from '../../routes';
import QuickBet from '../../components/coupon/quickbet/QuickBet';
import BetSlipList from '../../components/coupon/BetSlipList';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import MainMenu from '../../components/menu';
import Navigator from '../../components/Navigator';
import Loader from '../../components/Loader';
import { localization } from '../gridLocalization';
import { setCookie } from '../../cookiesUtils';
import { getQueryVariable } from '../../shared/sharedFunctions';
import preventDoubleTapZoom from '../../preventDoubleTapping';
import Coupons from '../../components/coupon/coupons';
import { resourceNames } from '../../constants/accountResourceNames';
import * as languages from '../../constants/Language';
import { loadBetSlips as loadBetSlipsAction } from '../../actions/coupon/creators/coupon';
import { FormattedMessage, defineMessages } from 'react-intl';
import ModalsContainer from './ModalsContainer';
import { FooterProvidersKG } from './footer-providers';
// import H1 from '../../components/SEO/H1.jsx'
import { SEO } from "../../SEO/getSeoByDomen";
var messages = defineMessages({
    copyright: {
        id: 'footer.copyright',
        defaultMessage: '© {year} Букмекерская компания «Fair Play»'
    },
    copyright_kz: {
        id: 'footer.copyright_kz',
        defaultMessage: '© {year} ТОО «BETtery». Торговая марка «Fair Play» Лицензия № 320 от 23.08.2019'
    },
    copyright_fp_gold: {
        id: 'footer.copyright_fp_gold',
        defaultMessage: '© {year} 18+ © 2023 ОсОО «Букмекерская контора «Траст Гейм». Торговое название «Fp Gold». Лицензия №007 от 23.08.2023',
    },
    title: {
        id: 'banner.title',
        defaultMessage: 'Бонусы'
    },
    daily: {
        id: 'banner.cashback.daily',
        defaultMessage: 'Ежедневный'
    },
    cashback: {
        id: 'banner.cashback.cashback',
        defaultMessage: 'кэшбэк'
    },
    footer_license_for_kg: {
        id: 'footer.license.for.kg',
        defineMessages: 'License # 193, issued on 09.10.2017'
    },
    follow_on_instagram: {
        id: 'follow.on.instagram',
        defaultMessage: 'Следите за конкурсами и бонусами в инстаграм'
    },
    footer_responsible_gaming: {
        id: 'content.regulations.responsibleGaming',
        defaultMessage: 'Ответственная игра'
    },
    footer_terms_and_conditions: {
        id: 'sidebar.information.termsAndConditions',
        defaultMessage: 'Правила'
    },
    footer_kyc_policy: {
        id: 'sidebar.information.kycPolicy',
        defaultMessage: 'Политика KYC'
    }
});
var root = document.getElementsByTagName('html')[0];
// const allowedAccountIds = [172370492];
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            settingsIsOpened: false,
        };
        _this.darkThemeHandler = function (isDark) {
            if (isDark) {
                document.body.classList.add('dark');
            }
            else {
                document.body.classList.remove('dark');
            }
        };
        _this.toggleUserMenu = function () {
            _this.props.toggleUserMenuAction(_this.props.userMenuToggled);
        };
        _this.toggleSidebar = function () {
            _this.props.toggleSidebarAction(_this.props.sidebarToggled);
        };
        _this.hideSidebar = function () {
            _this.props.sidebarToggled === false || _this.toggleSidebar();
        };
        _this.closeModal = function () {
            _this.props.closeQuickbetModalAction();
            _this.props.getFreebetAction();
            localStorage.setItem('couponAmountValue', '');
        };
        _this.closeBetSlipModal = function () {
            _this.props.closeBetSlipModalAction();
            _this.props.getFreebetAction();
        };
        _this.toggleSettingsBlock = function () {
            _this.setState(function (prevState) { return ({
                settingsIsOpened: !prevState.settingsIsOpened
            }); });
        };
        return _this;
    }
    App.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.routing.location.pathname !== prevProps.routing.location.pathname) {
            window.setTimeout(function () {
                window.scrollTo(0, 0);
            }, 1);
        }
    };
    App.prototype.componentDidMount = function () {
        window.beginSignIn = this.props.openAuthModalAction;
        this.darkThemeHandler(this.props.darkTheme);
        this.props.loadBetSlipsAction();
        root.addEventListener('gesturestart', function (e) {
            e.preventDefault();
        });
        var preLastTouchStartAt = 0;
        var lastTouchStartAt = 0;
        var delay = 500;
        (function () {
            var link = document.querySelector('link[rel="icon"]') || document.createElement('link');
            link.type = 'image/svg-xml';
            link.rel = 'shortcut icon';
            link.href = '/favicon.svg';
            document.getElementsByTagName('head')[0].appendChild(link);
        })();
        root.addEventListener('touchstart', function () {
            preLastTouchStartAt = lastTouchStartAt;
            lastTouchStartAt = +new Date();
        });
        root.addEventListener('touchend', function (event) {
            var touchEndAt = +new Date();
            if (touchEndAt - preLastTouchStartAt < delay) {
                event.preventDefault();
                event.target.click();
            }
        });
    };
    App.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.darkTheme !== this.props.darkTheme) {
            this.darkThemeHandler(nextProps.darkTheme);
        }
        if (nextProps.auth.user !== this.props.auth.user) {
            var isAuthenticated = Object.keys(nextProps.auth.user).length > 0 && nextProps.auth.user.constructor === Object;
            if (!isAuthenticated) {
                this.props.history.push('/');
                if (window.jivo_api) {
                    window.jivo_api.setContactInfo({});
                    window.jivo_api.setCustomData([]);
                }
            }
            if (isAuthenticated) {
                var user = nextProps.auth.user;
                this.props.getGamblerAction();
                if (window.jivo_api) {
                    window.jivo_api.setContactInfo({
                        'name': user.login
                    });
                    window.jivo_api.setCustomData([{
                            'content': "ID \u0438\u0440\u043E\u043A\u0430: ".concat(user.gamblerId, ", \u041B\u0438\u0446\u0435\u0432\u043E\u0439 \u0441\u0447\u0435\u0442: ").concat(user.accountNumber, ", \u043B\u043E\u0433\u0438\u043D: ").concat(user.login, ", \u0432\u0430\u043B\u044E\u0442\u0430: ").concat(resourceNames[user.accountResourceId]),
                        }]);
                }
            }
        }
        if (this.props.client.country !== nextProps.client.country || (this.props.client.fetched !== nextProps.client.fetched && nextProps.client.fetched === true)) {
            var elem = document.querySelector('#fpchat');
            if (elem !== null) {
                console.log('removeChild JIVO');
                elem.parentNode.removeChild(elem);
            }
            var bodyTag = document.getElementsByTagName('body')[0];
            var script = document.createElement('script');
            script.src = '//code.jivosite.com/widget.js';
            script.id = 'fpchat';
            script.setAttribute('id', 'fpchat');
            if (nextProps.client.country === 'UZ') {
                script.setAttribute('data-jv-id', 'gPpbnezxkt');
            }
            else {
                script.setAttribute('data-jv-id', 'ULPDklTeLj');
            }
            script.async = true;
            bodyTag.appendChild(script);
        }
        if (nextProps.authModalToggled || nextProps.registrationModalToggled || nextProps.registrationSuccessModalToggled ||
            nextProps.emailActivationModalToggled || nextProps.quickbetModalToggled || nextProps.betSlipModalToggled ||
            nextProps.thankYouModalToggled) {
            root.setAttribute('class', 'overflow-hidden');
        }
        else {
            root.setAttribute('class', '');
        }
    };
    ;
    App.prototype.componentWillMount = function () {
        if (this.props.auth.authenticated) {
            this.props.loadRestoreAction();
        }
        this.props.fetchClientInfoAction();
        if (!sessionStorage.getItem('notificationVisible')) {
            sessionStorage.setItem('notificationVisible', 'visible');
        }
        var promoName = getQueryVariable('mpromo');
        if (promoName) {
            this.props.appendPromoVisitAction(promoName);
            var options = {
                path: '/',
                expires: 7 * 24 * 60 * 60 * 1000,
                domain: 'mob.fp.kz'
            };
            setCookie('promo', promoName, options);
        }
    };
    App.prototype.render = function () {
        var _this = this;
        var _a = this.props, sidebarToggled = _a.sidebarToggled, quickbetModalToggled = _a.quickbetModalToggled, betSlipModalToggled = _a.betSlipModalToggled, gridLocalization = _a.gridLocalization, routing = _a.routing, languageId = _a.languageId, auth = _a.auth, client = _a.client;
        var settingsIsOpened = this.state.settingsIsOpened;
        var cls = !sidebarToggled ? '' : 'with_menu';
        var showCoupon = !window.location.pathname.includes("/games");
        var preventDT = preventDoubleTapZoom;
        if (auth.isAuthenticating && !client.fetched) {
            return _jsx(Loader, {});
        }
        var quickBetProps = {
            close: this.closeModal,
            quickbetModalToggled: quickbetModalToggled,
            gridLocalization: gridLocalization
        };
        var betSlipProps = {
            close: this.closeBetSlipModal,
            betSlipModalToggled: betSlipModalToggled,
            gridLocalization: gridLocalization
        };
        var pathname = routing.location.pathname;
        var seo = SEO()[pathname] ? SEO()[pathname] : SEO()['/'];
        var age = client.country === 'KZ' ? '21+' : '18+';
        var defaultCopyright = messages.copyright;
        var copyrightMessage = defaultCopyright;
        var hideMenuPages = ['/add-card/success', '/add-card', '/profile', '/results', '/activate', '/history', '/unsettled-bets', '/account-history', '/withdraw', '/recharge', '/recharge/success', '/recharge/failure', '/checks-usdt', '/opex-instruction', '/bonus', '/terms_and_conditions', '/help', '/privacy_policy', '/kyc_policy', '/responsible', '/404', '/fp_gold', '/identify', '/st', '/go'];
        var hideMenu = hideMenuPages.find(function (hidePath) { return hidePath === pathname; });
        if (pathname === '/combobet' && client.country === 'KG') {
            return (_jsx("div", __assign({ onTouchStart: preventDT }, { children: routes(gridLocalization) })));
        }
        return (_jsxs("div", __assign({ className: "".concat(cls), onTouchStart: preventDT }, { children: [_jsx(Sidebar, { settingsIsOpened: settingsIsOpened, languageId: languageId, toggleSettingsBlock: this.toggleSettingsBlock }), _jsxs("div", __assign({ id: 'main', onClick: this.hideSidebar }, { children: [_jsx(Header, { match: this.props.match }), _jsxs("div", __assign({ id: 'wrapper', onClick: function () { _this.props.userMenuToggled === true && _this.toggleUserMenu(); } }, { children: [!hideMenu && _jsx(MainMenu, { activeTab: this.props.activeTab }), routes(gridLocalization), showCoupon && this.props.betSlips.size > 0 && _jsx(Coupons, {})] })), pathname !== '/cybersport' && pathname !== '/withdraw' && pathname !== '/recharge' &&
                            _jsxs("div", __assign({ id: 'footer' }, { children: [pathname !== '/cybersport' && pathname !== '/withdraw' && pathname !== '/recharge' && pathname !== '/games' && _jsx(Navigator, { languageId: languageId, country: client.country }), _jsxs("div", __assign({ style: { display: 'flex' } }, { children: [_jsx("div", __assign({ className: 'user-age' }, { children: age })), _jsx("div", __assign({ className: 'copyright-text' }, { children: _jsx(FormattedMessage, __assign({}, copyrightMessage, { values: { year: new Date().getFullYear() } })) }))] })), _jsx("p", __assign({ style: { fontSize: 10, color: '#a6a6a6', textAlign: 'center', margin: '10px', lineHeight: '1.5', maxWidth: '600px' } }, { children: languageId === languages.UZ ? (_jsxs(React.Fragment, { children: ["fp.gold SmartPlay Interactive Limitada kompaniyasiga tegishli va u tomonidan boshqariladi, ro'yxatdan o'tish raqami: 3-102-911868, ro'yxatdan o'tish manzili: Kosta-Rika, San Pedro, Barrio Dent, Del Centro Cultural Costarricense Norteamericano, Do Scientos Metros Al Norte y Cincuenta Al Este, Edificio Ofident, Oficina Numero Tres. Biz bilan bog'laning: support@fp.gold.", _jsx("br", {}), "fp.gold Komor orollari ittifoqidagi Anjuan avtonom oroli hukumati tomonidan litsenziyalangan va tartibga solinadi hamda ALSI-202411067-FI2-sonli litsenziya asosida faoliyat yuritadi. fp.gold barcha me'yoriy tekshiruvlardan o'tgan va barcha turdagi qimor o'yinlari hamda stavkalar bo'yicha qonuniy ravishda faoliyat yuritishga vakolatli."] })) : (_jsxs(React.Fragment, { children: ["fp.gold is owned and operated by SmartPlay Interactive Limitada, registration number: 3-102-911868, registered address: Costa Rica, San Pedro, Barrio Dent, Del Centro Cultural Costarricense Norteamericano, Do Scientos Metros Al Norte y Cincuenta Al Este, Edificio Ofident, Oficina Numero Tres. Contact us support@fp.gold.", _jsx("br", {}), "fp.gold is licensed and regulated by the Government of the Autonomous Island of Anjouan, Union of Comoros and operates under License No. ALSI-202411067-FI2 fp.gold has passed all regulatory compliance and is legally authorized to conduct gaming operations for any and all games of chance and wagering."] })) })), client.country === 'KG' && _jsx(FooterProvidersKG, {})] }))] })), quickbetModalToggled && _jsx(QuickBet, __assign({}, quickBetProps)), betSlipModalToggled && _jsx(BetSlipList, __assign({}, betSlipProps)), _jsx(ModalsContainer, {}), _jsxs(Helmet, { children: [_jsx("title", { children: seo.title }), _jsx("meta", { name: "description", content: seo.description }), _jsx("meta", { name: "keywords", content: seo.keywords.join(',') })] }), _jsx(Helmet, { children: _jsx("link", { rel: "canonical", href: window.location.href }) })] })));
    };
    return App;
}(React.Component));
App.propTypes = {
    sidebarToggled: PropTypes.bool.isRequired,
    fetchClientInfoAction: PropTypes.func.isRequired,
    getGamblerAction: PropTypes.func.isRequired,
    openQuickbetModalAction: PropTypes.func.isRequired,
    closeQuickbetModalAction: PropTypes.func.isRequired,
    openBetSlipModalAction: PropTypes.func.isRequired,
    closeBetSlipModalAction: PropTypes.func.isRequired,
    toggleSidebarAction: PropTypes.func.isRequired,
    toggleUserMenuAction: PropTypes.func.isRequired,
    quickbetModalToggled: PropTypes.bool.isRequired,
    authModalToggled: PropTypes.bool.isRequired,
    registrationModalToggled: PropTypes.bool.isRequired,
    emailActivationModalToggled: PropTypes.bool.isRequired,
    thankYouModalToggled: PropTypes.bool.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    auth: PropTypes.object,
    loadRestoreAction: PropTypes.func.isRequired,
    signInAction: PropTypes.func.isRequired,
    registrationSuccessModalToggled: PropTypes.bool.isRequired,
    appendPromoVisitAction: PropTypes.func.isRequired,
    promo: PropTypes.any,
    freebets: PropTypes.array.isRequired,
    userMenuToggled: PropTypes.bool.isRequired,
    loadBetSlipsAction: PropTypes.func.isRequired,
    betSlips: PropTypes.object.isRequired,
    darkTheme: PropTypes.bool.isRequired,
};
var mapStateToProps = function (state) { return ({
    routing: state.routing,
    authModalToggled: state.auth.authModalToggled,
    registrationModalToggled: state.registration.registrationModalToggled,
    emailActivationModalToggled: state.registration.emailActivationModalToggled,
    thankYouModalToggled: state.registration.thankYouModalToggled,
    activeTab: state.application.get('activeTab'),
    sidebarToggled: state.application.get('sidebarToggled'),
    userMenuToggled: state.application.get('userMenuToggled'),
    quickbetModalToggled: state.application.get('quickbetModalToggled'),
    betSlipModalToggled: state.application.get('betSlipModalToggled'),
    languageId: state.application.get('languageId'),
    gridLocalization: localization(state.application.get('languageId')),
    auth: state.auth,
    promo: state.promo,
    registrationSuccessModalToggled: state.registration.registrationSuccessModalToggled,
    freebets: state.auth.freebets,
    betSlips: state.coupon.get('betSlips'),
    client: state.application.get('client'),
    darkTheme: state.application.get('darkTheme'),
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    openQuickbetModalAction: openQuickbetModalAction,
    closeQuickbetModalAction: closeQuickbetModalAction,
    openBetSlipModalAction: openBetSlipModalAction,
    closeBetSlipModalAction: closeBetSlipModalAction,
    toggleSidebarAction: toggleSidebarAction,
    loadRestoreAction: loadRestoreAction,
    signInAction: signInAction,
    appendPromoVisitAction: appendPromoVisitAction,
    toggleUserMenuAction: toggleUserMenuAction,
    fetchClientInfoAction: fetchClientInfoAction,
    getGamblerAction: getGamblerAction,
    loadBetSlipsAction: loadBetSlipsAction,
    getFreebetAction: getFreebetAction,
    openAuthModalAction: openAuthModalAction,
}, dispatch); };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/app/index.js